import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import IButtonComponent from '../iComponents/iButton/IButton';
import { descargarExcelDesdeJSON } from '../../../helpers/generatePackingList';
import { getPackingListgCommodity } from '../../../store/actions';
import Iloading from '../iComponents/iLoading/Iloading';

const PackingList = ({ CommodityList, groupName }: any) => {

  const dispatch = useDispatch();

  const { packingList, isLoading } = useSelector(
    (state: any) => state.Commodity,
  );
  const [dataList, setDataList] = useState<any>([]);

  useEffect(() => {
    if (packingList) {
      setDataList(packingList);
    }
  }, [packingList]);

  useEffect(() => {
    dispatch(getPackingListgCommodity({ GUID: CommodityList.GUID, groupName: groupName }))
  }, [CommodityList])


  const DownloadPackingList = () => {
    descargarExcelDesdeJSON(dataList,groupName)
  }


  return (
    <div>
      <Iloading loading={isLoading} />
      {dataList ? (<>
        <IButtonComponent
          actionOnClick={DownloadPackingList}
          className="btn-search"
          label={'Packing List'}
          btnIcon="bx bx-down-arrow-alt"
        ></IButtonComponent>
      </>
      )
        : null}
    </div>
  )
}

export default PackingList